import { createDocModalExecutor } from '@organisms/actions/createDocModalExecutor';
import { ILoadFromFileExecutorProps } from './ILoadFromFileExecutorProps';
import { LoadFromFileExecutorModal } from './LoadFromFileExecutorModal';

export const LoadFromFileExecutor = createDocModalExecutor<ILoadFromFileExecutorProps>({
    modal: LoadFromFileExecutorModal,
    defaultModalSize: 'xl',
    emptyElement: <div />,
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        docId: objId ?? '',
        actionKey: action.key ?? '',
        title: action.options?.title ?? '',
        jobTitle: action.baseDisplayName || action.displayName,
        okButtonText,
        cancelButtonText,
        modalSize,
        allowedFileTypes: action.options?.allowedFileTypes ?? '',
        showResult: action.options?.showResult ?? false,
        runInBackground: action.options?.runInBackground ?? false,
        successText: action.options?.successText,
        completeHandler,
    }),
});
